/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { TableCell, TableRow } from "@material-ui/core";
import Icon from "react-icons-kit";
import { angleRight } from "react-icons-kit/fa/angleRight";
import { angleDown } from "react-icons-kit/fa/angleDown";

import { Text } from "UpduoLibrary";
import { skaleWebBlueGray, skaleWhite } from "config/UpduoColors";

export default function StoreRow({ isExpanded, rowData, onClick }) {
  // Row cells (TableRowColumn components) must be in an array,
  // so that we can push an indeterminate number of skill mastery cells

  const allRowCells = [
    <TableCell
      key={0}
      style={{
        backgroundColor: skaleWebBlueGray,
        padding: 0,
        alignItems: "center",
      }}
    >
      <View
        style={{ flexDirection: "row", height: "100%", alignItems: "center" }}
      >
        <div style={{ color: skaleWhite, padding: 2 }}>
          <Icon size={18} icon={isExpanded ? angleDown : angleRight} />
        </div>
        <Text style={{ color: skaleWhite }}>{rowData.name}</Text>
      </View>
    </TableCell>,
    <TableCell
      key={1}
      style={{
        backgroundColor: skaleWebBlueGray,
        alignItems: "center",
      }}
    >
      <View style={{ flexDirection: "row" }}>
        <Text style={{ color: skaleWhite, flex: 1 }}>{"Members: "}</Text>
        <Text style={{ color: skaleWhite, flex: 1 }}>{rowData.user_count}</Text>
      </View>
    </TableCell>,
    <TableCell
      key={2}
      style={{
        backgroundColor: skaleWebBlueGray,
        alignItems: "center",
      }}
    />,
    <TableCell
      key={3}
      style={{
        backgroundColor: skaleWebBlueGray,
        alignItems: "center",
      }}
    >
      <View style={{ alignItems: "center" }}>
        <Text style={{ color: skaleWhite }}>{rowData.session_count}</Text>
      </View>
    </TableCell>,
    <TableCell
      key={4}
      style={{
        backgroundColor: skaleWebBlueGray,
        alignItems: "center",
      }}
    />,
  ];

  const skillsStartedCount = rowData.user_skill_mastery_count;
  skillsStartedCount.forEach((item, itemIndex) => {
    allRowCells.push(
      <TableCell
        key={5 + itemIndex}
        style={{
          padding: 0,
          backgroundColor: skaleWebBlueGray,
        }}
      >
        <View
          style={{
            flex: 1,
            height: "100%",
            backgroundColor: skaleWebBlueGray,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text style={{ color: skaleWhite }}>{item}</Text>
        </View>
      </TableCell>
    );
  });

  return (
    <TableRow
      hover={true}
      onClick={() => {
        onClick(isExpanded);
      }}
    >
      {allRowCells}
    </TableRow>
  );
}
